import { render, staticRenderFns } from "./DepositsReceipt.vue?vue&type=template&id=dc225b18&"
import script from "./DepositsReceipt.vue?vue&type=script&lang=js&"
export * from "./DepositsReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports